import axios from "axios";

const state = {
  chat: [],
  chatPage: 0,
};

const getters = {
  chat(state) { return state.chat },
  chatPage(state) { return state.chatPage },
};

const actions = {
  getChat({ commit, getters }) {
    commit('INCREMENT_PAGE', getters.chatPage + 1);
    axios.get(process.env.VUE_APP_API_URL + 'chat/get_paginated_chat?page=' + getters.chatPage)
      .then(response => {
        commit('SET_CHAT', response.data.data);
      })
  },
  incrementPage({ commit, getters }) {
    commit('SET_PAGE', getters.chatPage++);
  },
  addNewChat({ commit }, newChat) {
    commit('SET_NEW_CHAT', newChat);
  }
};

const mutations = {
  SET_CHAT(state, data) { state.chat = [...state.chat, ...data] },
  INCREMENT_PAGE(state, newPage) { state.chatPage = newPage },
  SET_NEW_CHAT(state, newChat) { state.chat.unshift(newChat) }
};


export default {
  state,
  getters,
  actions,
  mutations,
}
